import { useEffect, useState, useContext } from "react";
import { CircularProgress } from "@mui/material";
import MUICard from "./../../../Component/UI/MUICard/MUICard";
import classes from "./History.module.css";
import HistoryItem from "./HistoryItem";
import LoadingSkeleton from "./LoadingSkeleton";
import EmptyView from "./../../../Component/EmptyView/EmptyView";
import { AuthContext } from "../../../context/auth-context";
import useHistory from "./useHistory";
import MUIButton from "./../../../Component/UI/MUIButton/MUIButton";
import ErrorView from "./../../../Component/ErrorView/ErrorView";
import ErrorMessage from "./../../../Component/ErrorMessage/ErrorMessage";
const PAGE_LIMIT = 5;

export default function History({ filter = "brand", updateStatesFromHistory }) {
  const [filterOption, setFilterOption] = useState(filter);
  const { authUserEmail } = useContext(AuthContext);
  const [page, setPage] = useState(1);
  const {
    history,
    loading,
    getHistory,
    hasReachedEnd,
    deleteHistory,
    updateHistory,
    error,
  } = useHistory(authUserEmail, filterOption);

  useEffect(() => {
    setFilterOption(filter);
    setPage(1);
  }, [filter]);

  useEffect(() => {
    getHistory(page, PAGE_LIMIT);
  }, [page, filterOption]);

  function deleteHistoryItemHandler(id) {
    deleteHistory(id);
    if (history.length === 1) {
      setPage((page) => page + 1);
    }
  }

  return (
    <MUICard variant="elevated" elevation={0} className={classes.card}>
      <div className={classes.header}>
        <span className={classes.title}>History</span>
      </div>
      {history.length > 0 && (
        <div className={classes.container}>
          {history.map((historyItem) => (
            <HistoryItem
              key={historyItem.id}
              item={historyItem}
              onDelete={deleteHistoryItemHandler}
              onUpdate={(id, name) => updateHistory(id, name)}
              updateStatesFromHistory={updateStatesFromHistory}
            />
          ))}
          <div className={classes.load_more}>
            {error && history.length > 0 && (
              <div className={classes.error_message}>
                <ErrorMessage message={error} />
              </div>
            )}
            {!loading && !hasReachedEnd && (
              <MUIButton
                className={classes.load_btn}
                variant="text"
                onClick={() => setPage((page) => page + 1)}
              >
                Load More
              </MUIButton>
            )}
            {loading && <CircularProgress size={22} />}
          </div>
        </div>
      )}
      {loading && history.length === 0 && <LoadingSkeleton />}
      {!loading && !error && history.length === 0 && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "70%" }}
        >
          <EmptyView message={"Nothing here."} />
        </div>
      )}
      {error && history.length === 0 && (
        <div className={classes.error}>
          <ErrorView title="Error" message={error} />
        </div>
      )}
    </MUICard>
  );
}
